import { useEffect, useState, useRef } from 'react';
import styleButton from './ConnectWallet.module.scss';
import { WalletTab } from '../WalletTab/WalletTab';
import { addressFormate, formatNumber } from '../../../../_utils';
import { useAppDispatch, useAppSelector, useIsLoggedSelector } from '../../../../services/hooks.service';
import { useTranslation } from 'react-i18next';
import { updateSelectedWalletBalance } from '../../../../redux/_actions/user.action';
import { updateWalletData } from '../../../../services/wallet.service';
import { useConnectWallet, useOnClickOutside } from '../../../../hooks';
import classNames from 'classnames';
import { useBalances } from '../../../../wallets/useBalances';
import { BLOCKCHAINS, CHAIN_LOGO } from '../../../../wallets/providers';
import { useActiveAccount } from '../../../../wallets/useActiveAccount';
import { saveUserAssets } from '../../../../redux/_actions/wallet.action';
import { saveDollarPrices } from '../../../../redux/_actions/exchange.action';
import { SolanaConnector } from '../../../../wallets/solana/solana.service';
import { useViewportInfo } from '../../../../hooks/useViewportInfo';
import { initialExchangeAssetsState, useGetCodexAssetsQuery } from '@ultrade/react-sdk';

const solanaConnector = SolanaConnector.getInstance();
export const WALLET_UPDATE_INTERVAL = 5000;
export const WALLET_UPDATE_INTERVAL_SOLANA = 15000;
const DOLLAR_PRICE_INTERVAL = 600000; //10 min

export const ConnectWallet = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isLogged = useIsLoggedSelector();
  const { connectWalletModal, connectWallet } = useConnectWallet();
  const activeWallet = useActiveAccount();
  const {getBalances, nativeCurrency} = useBalances();
  const { smallWalletView } = useViewportInfo();
  const walletTab = useRef<HTMLDivElement>();
  
  // const codexAssets = useAppSelector((state) => state.exchange.exchangeAssets);
  const sdkClient = useAppSelector((state) => state.sdkClient.instance);
  const {data: codexAssets = initialExchangeAssetsState} = useGetCodexAssetsQuery(undefined);

  const balance = useAppSelector((state) => state.user.activeBalance);
  const [walletSettings, setWalletSettings] = useState(false);
  useOnClickOutside(walletTab, () => setWalletSettings(false));

  const update = async () => {
    if (!activeWallet?.address) {
      dispatch(saveUserAssets([]));
      return;
    }
    getBalances()
      .then(balances => dispatch(updateSelectedWalletBalance(balances?.formatted)))
      .catch(err => {
        if (err.message?.includes("TypeError: Failed to fetch")
         || err.message?.includes("TimeoutError: The request took too long to respond")) {
          return;
        }
        console.log('Error on get balance: ', err);
      });
  };

  useEffect(() => {
    update();
    updateWalletData(activeWallet?.address, activeWallet?.chain);
    const timerId = setInterval(update, WALLET_UPDATE_INTERVAL);
    let timerId2;
    if (activeWallet?.chain !== BLOCKCHAINS.SOLANA) {
      timerId2 = setInterval(() => updateWalletData(activeWallet?.address, activeWallet?.chain), WALLET_UPDATE_INTERVAL);
    }

    return () => {
      clearInterval(timerId);
      clearInterval(timerId2);
    };
  }, [activeWallet?.address, activeWallet?.chain, codexAssets.length]);

  useEffect(() => {
    let timerId;
    if (walletSettings && activeWallet?.chain === BLOCKCHAINS.SOLANA) {
      updateWalletData(activeWallet?.address, activeWallet?.chain);
      timerId = setInterval(() => updateWalletData(activeWallet?.address, activeWallet?.chain), WALLET_UPDATE_INTERVAL_SOLANA);  
    }
    return () => { clearInterval(timerId) };
  }, [walletSettings, activeWallet?.chain, activeWallet?.address]);

  useEffect(() => {
    const loadDollarInfo = async () => {
      sdkClient.getDollarValues()
        .then((dollarValues) => dispatch(saveDollarPrices(dollarValues)))
        .catch(e => console.log('Error on get dollar price: ', e))
    }
    loadDollarInfo();
    const timerId = setInterval(loadDollarInfo, DOLLAR_PRICE_INTERVAL);
    return () => {
      clearInterval(timerId);
    };
  }, []);

  useEffect(() => {
    if (activeWallet?.chain === BLOCKCHAINS.SOLANA) {
      let changeEvent = false;
      window.solana?.on('accountChanged', (newPublicKey) => {
        if (!changeEvent) {
          changeEvent = true;
          console.log("WORK event accountChanged", newPublicKey.toString())
          solanaConnector.switch(activeWallet?.chain, activeWallet?.provider)
          .then(() => changeEvent = false);
        }
      });
    }
    return () => { 
      window.solana?.off('accountChanged');
    };
  }, [activeWallet?.chain]);

  const openWalletTab = () => {
    setWalletSettings(!walletSettings);
  };

  return (
    <>
      <div className={styleButton.wallet_cont} data-testid="connect_wallet_btn" ref={walletTab}>
        {activeWallet?.address ? (
          <p className={styleButton.button_border}>
            <button
              className={classNames(styleButton.amm_connect_wallet, styleButton.transparent_wallet)}
              onClick={openWalletTab}
            >
              <span className={styleButton.button_balance} data-testid="button_balance">
                {balance && formatNumber(balance)} {nativeCurrency?.symbol}
              </span>
              <span className={styleButton.button_address} data-testid="button_address">
                {!!activeWallet?.chain && <img className={styleButton.logo} src={CHAIN_LOGO[activeWallet?.chain]} alt="icon" />}
                {addressFormate((activeWallet?.address), smallWalletView ? 3 : 6)}
              </span>
              <i
                className={
                  walletSettings ? 'fa fa-angle-up' : 'fa fa-angle-down'
                }
                aria-hidden="true"
              ></i>
            </button>
          </p>
        ) : (
          <button
            className={styleButton.amm_connect_wallet}
            onClick={connectWallet}
          >
            {t('connectWallet.connect__wallet_text')}
          </button>
        )}
        <div
          className={
            walletSettings
              ? styleButton.wallets_block
              : styleButton.wallets_block_none
          }
        >
          <WalletTab
            walletAddress={activeWallet?.address}
            closeTab={setWalletSettings}
          />
        </div>
      </div>
      {connectWalletModal()}
    </>
  );
};